module.exports = __webpack_public_path__ + "media/images/city/015-aqueduct-of-segovia-252bc6356bf8ff51bd02d1f9b8f025ce.svg";